import { Node } from "../../src/shell/Actions/Action";
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { empty } from "../characters/empty";
import { joe } from "../characters/Joe";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { doImageShake, doPutBlackImage, doPutMultipleImages, doTransition, doWaitImageByTime, isMcLikesNTR } from "../helpers/helpers";
import { images } from "./images";
import { V8VanessaJoeMCThreesomeAfter } from "./V8";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";

const v8 = images.v8;
export const V8VanessaJoeMCThreesome = async (): Promise<Node<unknown>> => {
    let jennyDate = false;
    if (Game.seenScenarios.includes(`V8JennyDate`)) {
        jennyDate = true;
        doTransition(images.v8.V8BeforeUnderpass_15);
        mc.think(`They are already here.`);
        mc.talk(`Yoooo!`, { method: "Shouting" });
        mc.think(`I better let Joey drive, it's his car after all.`);


    } else {
        doTransition(images.v8.V8RoomNight);
        empty.think(`*Phone Rings*`);
        ImageClass.setImage(images.v8.V8RoomNightOnPhone);
        joe.talk(`Sup Bro? We are outside!`);
        mc.talk(`Cool, I'm coming.`);
        doTransition(images.v8.V8BeforeUnderpass_5);
        mc.think(`Here they are.`);
        doWaitImageByTime(images.v8.V8BeforeUnderpass_0);
        mc.talk(`What's with the coat? Is it raining?`);
        vanessa.talk(`Stop playing dumb, you know I can't leave my house with my normal clothes.`);
        mc.talk(`Right.`);

    }
    if (jennyDate) {
        doWaitImageByTime(images.v8.V8BeforeUnderpass_4);
        vanessa.talk(`Where have you been?`);
        if (mc.properties.annStatus === "gf") {
            vanessa.talk(`I know for a fact you haven't been with Ann.`);

        }
        doWaitImageByTime(images.v8.V8BeforeUnderpass_3);
        mc.talk(`Nowhere important...`);
        doWaitImageByTime(images.v8.V8BeforeUnderpass_4);
        vanessa.talk(`Right.`);
        doWaitImageByTime(images.v8.V8BeforeUnderpass_2);
    } else {

        doWaitImageByTime(images.v8.V8BeforeUnderpass_1);
    }
    mc.talk(`So, where are we going?`);
    if (!jennyDate) {
        doWaitImageByTime(images.v8.V8BeforeUnderpass_2);
    }
    vanessa.talk(`You'll see.`);
    ImageClass.setImage(images.v8.V8BeforeUnderpass_4);
    vanessa.talk(`Does it really matters?`);
    ImageClass.setImage(images.v8.V8BeforeUnderpass_3);
    mc.talk(`Not really.`);
    ImageClass.setImage(images.v8.V8BeforeUnderpass_4);
    vanessa.talk(`Right.`);
    ImageClass.setImage(images.v8.V8BeforeUnderpass_2);
    vanessa.talk(`Let's go.`);
    doTransition(images.v8.V8BeforeUnderpass_6);
    if (Game.seenScenarios.includes(`V6Underpass`)) {
        mc.talk(`This place again?`);
        ImageClass.setImage(images.v8.V8BeforeUnderpass_7);
        vanessa.talk(`Of course! It's the perfect place.`);
        mc.talk(`Have you forgotten about last time?`);
        mc.talk(`What if that cop shows up again?`);
        vanessa.talk(`Relax, he won't. It was a fluke he showed up here last time.`);
        mc.talk(`I hope you are right. I don't want to get arrested.`);
    } else {
        mc.talk(`What is this place?`);
        vanessa.talk(`The best place for our little party!`);
        mc.talk(`What's wrong with one of our houses?`);
        vanessa.talk(`I don't want any interruptions.`);
        vanessa.talk(`No one comes here; it's the perfect place!`);
        mc.talk(`If you say so.`);
    }
    vanessa.talk(`Let's go settle in.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_126);
    vanessa.talk(`Before we start...`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_127);
    vanessa.talk(`Let me...`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_128);
    vanessa.talk(`take...`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_129);
    vanessa.talk(`this...`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_130);
    vanessa.talk(`thing...`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_131);
    vanessa.talk(`off...`);
    mc.talk(`Oh... So that's what you were hiding.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_0);
    vanessa.talk(`So how are we going to start?`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_1);
    vanessa.talk(`Should I start with you?`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_2);
    vanessa.talk(`Or should I start with my baby?`);
    if (Question.globalAnswers.v7JoeGymToldBreakupVanessa) {
        mc.think(`Baby? I thought they broke up...`);
        mc.think(`Maybe they just don't want to ruin the mood.`);

    }
    mc.talk(`Hmmm... You're supposed to be the threesome specialist.`);
    joe.talk(`I think we should let ${mc.name} decide, so he'll feel more comfortable.`);
    vanessa.talk(`Great idea!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_3);
    vanessa.talk(`What do you say?`);
    return jump(V8VanessaJoeMCThreesome_2, "V8VanessaJoeMCThreesome_2");
};

export const V8VanessaJoeMCThreesome_2 = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8MCJoeVanessa_4);
    vanessa.talk(`It's totally up to you.`);
    vanessa.talk(`You are our "special guest" after all...`);
    vanessa.talk(`Joe and I agreed that you should do whatever makes you feel comfortable.`);
    await vanessa.setQuestion(new Question({ text: `Who do you think should go first?`, options: { think: false }, key: `v8VanessaJoeThreesomeStartFirst` })
        .option({ title: `Me`, key: true })
        .option({ title: `Joey`, key: false }));


    if (Question.globalAnswers.v8VanessaJoeThreesomeStartFirst) {

        return jump(V8VanessaJoeMCThreesome_MCFirst, "V8VanessaJoeMCThreesome_MCFirst");

    }

    return jump(V8VanessaJoeMCThreesome_JoeFirst, "V8VanessaJoeMCThreesome_JoeFirst");

};

export const V8VanessaJoeMCThreesome_MCFirst = async (): Promise<Node<unknown>> => {
    ImageClass.setImage(images.v8.V8MCJoeVanessa_4.partials.V8MCJoeVanessa_5);
    mc.talk(`I'll go first.`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_4);
    vanessa.talk(`Excellent choice!`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_6);
    vanessa.talk(`After all, you are our special guest.`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_7);
    vanessa.talk(`And you should get special treatment.`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_6);
    vanessa.talk(`We can start by having you remove your clothes.`);
    doTransition(images.v8.V8MCJoeVanessa_8);
    vanessa.talk(`Much better!`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_9);
    vanessa.talk(`Oh! You are already hard. Very nice.`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_12);
    mc.think(`I can't believe Joey is sitting there and watching his girl suck my dick...`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_11);
    vanessa.talk(`Honey, don't worry, I'll be with you in a second.`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_13);
    if (Question.globalAnswers.v4SexTapeFuckedVanessa || Question.globalAnswers.v6HadSexVanessaLivingRoom || Question.globalAnswers.v3VanessaCoffeeJustSuckIt) {
        mc.think(`God, I missed her mouth.`);
    } else {
        mc.think(`Damn! She definitely knows what she is doing.`);
    }
    vanessa.talk(`Mmm...`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_10);
    vanessa.talk(`Honey, why are you still dressed?`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_16);
    vanessa.talk(`That was quick!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_17);
    vanessa.talk(`Are you ready for me?`);
    joe.talk(`Of course! Come over here!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_18);
    mc.think(`Vanessa is approaching Joey...`);

    await mc.setQuestion(new Question({ text: `They both agreed that I'm their special guest and could do whatever I want...`, options: { think: true }, key: `v8VanessaJoeThreesomeGrabbedVanessa` })
        .option({ title: `Grab her`, key: true })
        .option({ title: `Let her continue`, key: false }));


    if (Question.globalAnswers.v8VanessaJoeThreesomeGrabbedVanessa) {
        return jump(V8VanessaJoeMCThreesome_GrabVanessa, "V8VanessaJoeMCThreesome_GrabVanessa");
    }


    return jump(V8VanessaJoeMCThreesome_DontGrabVanessa, "V8VanessaJoeMCThreesome_DontGrabVanessa");
};
export const V8VanessaJoeMCThreesome_GrabVanessa = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8MCJoeVanessa_19);
    mc.talk(`I'm not done.`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_20);
    vanessa.talk(`Look who showed up to the party!`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_22);
    vanessa.talk(`Sorry honey, you'll have to wait.`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_21);
    vanessa.talk(`${mc.name} didn't get enough of me just yet.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_24);
    mc.talk(`Oh yes!`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_25);
    mc.think(`It feels so good!`);
    ImageClass.setImage(images.v8.Anim_V8MCJoeVanessaMCBJ.poster);
    vanessa.talk(`Slurp...`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaMCBJ);
    mc.talk(`Ah...`);


    doWaitImageByTime(images.v8.V8MCJoeVanessa_28);
    await vanessa.setQuestion(new Question({ text: `Maybe it's time to let Joey join?`, options: { think: false }, key: `v8VanessaJoeThreesomeGrabbedVanessaLetJoeyJoin` })
        .option({ title: `Let Joey join`, key: true })
        .option({ title: `Don't let him`, key: false }));


    if (Question.globalAnswers.v8VanessaJoeThreesomeGrabbedVanessaLetJoeyJoin) {
        mc.talk(`Of course, go show him some love.`);
        return jump(V8VanessaJoeMCThreesome_DontGrabVanessa, "V8VanessaJoeMCThreesome_DontGrabVanessa");
    }
    return jump(V8VanessaJoeMCThreesome_GrabVanessa_DontLetJoeyJoin, "V8VanessaJoeMCThreesome_GrabVanessa_DontLetJoeyJoin");


};

export const V8VanessaJoeMCThreesome_GrabVanessa_DontLetJoeyJoin = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8MCJoeVanessa_27);
    mc.talk(`He'll be fine a little longer.`);
    vanessa.talk(`I see.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_29);
    vanessa.talk(`What do you want me to do?`);
    mc.talk(`Come on top of me.`);

    doWaitImageByTime(images.v8.V8MCJoeVanessa_30);
    mc.think(`The tease is unreal!`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_31);
    vanessa.talk(`How are you holding up hon?`);
    joe.talk(`Can't wait to join!`);
    vanessa.talk(`I'm sure ${mc.name} will let you join any minute now!`);
    mc.think(`Fifty-fifty chance.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_32);
    mc.think(`Damn, my cock against her leather pants feel so good.`);
    vanessa.talk(`Fuck! Stop rubbing your cock on me! I'm about to explode!`);
    mc.talk(`What are you waiting for then?`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_33);
    vanessa.talk(`I was waiting for you to say just that!`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_34);
    if (Question.globalAnswers.v6HadSexVanessaLivingRoom || Question.globalAnswers.v4SexTapeFuckedVanessa) {
        mc.think(`I'm about to get a taste of that pussy once again!`);
    } else {
        mc.think(`Finally I'm about to get a taste of that pussy!`);
    }
    doWaitImageByTime(images.v8.Anim_V8MCJoeVanessaCowgirl.poster);
    mc.think(`Damn!`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaCowgirl);
    vanessa.talk(`Oh yeah! Just like that!`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaRidingMCJoeLooking);
    vanessa.talk(`Your cock feels sooo good!`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaCowgirl, { speed: 1.5 });
    vanessa.talk(`Yes! Yes! Fuck me!!`);
    mc.think(`Vanessa keeps looking at Joey the entire time I'm fucking her... Such a tease.`);
    doWaitImageByTime(images.v8.Anim_V8MCJoeVanessaOnVanessa.poster);
    vanessa.talk(`Oh yes! Take control!`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaOnVanessa);
    vanessa.talk(`You can do whatever you want with me!`);
    // ImageClass.setImage(images.v8.V8MCJoeVanessa_41);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaOnVanessa, { speed: 1.1 });
    vanessa.talk(`Harder! HARDER!`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaOnVanessa, { speed: 1.3 });
    // ImageClass.setImage(images.v8.V8MCJoeVanessa_40);
    vanessa.talk(`Is that all you got?`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaOnVanessa, { speed: 1.5 });
    mc.talk(`Time to shut you up a bit!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_44);
    mc.talk(`Now ask me to go harder!`);
    doWaitImageByTime(images.v8.Anim_V8MCJoeVanessaMCBJUpsidedownSlow.poster);
    vanessa.talk(`Mmm!!!`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaMCBJUpsidedownSlow, { loop: 0 });
    mc.think(`Her throat feels so good! My cock slides right in.`);
    doWaitImageByTime(images.v8.Anim_V8MCJoeVanessaMCBJUpsidedownMedium.poster);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaMCBJUpsidedownMedium);
    vanessa.talk(`J... Slurp... O... Slurp... E...?`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaMCBJUpsidedownWJoe);
    mc.think(`Is she trying to call for Joey?`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaMCBJUpsidedownFast);
    vanessa.talk(`Slurp!!!`);
    doWaitImageByTime(images.v8.Anim_V8MCJoeVanessaMCDoggy.poster);
    vanessa.talk(`Oh yeah! My favorite position!`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaMCDoggy);
    await empty.set((properties) => {
        properties.v8ThreesomeMCAlonePosition = "doggy";
    });

    return jump(V8VanessaJoeMCThreesome_GrabVanessa_Choices, "V8VanessaJoeMCThreesome_GrabVanessa_Choices");
};


export const V8VanessaJoeMCThreesome_GrabVanessa_Choices = async (): Promise<any> => {
    // TODO: write additional dialogues for this part
    if (Question.globalAnswers.v8VanessaJoeThreesomeMCAlone === "missionary") {
        doWaitImageByTime(images.v8.V8MCJoeVanessa_41, { wait: true });
        ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaOnVanessa);


    } else if (Question.globalAnswers.v8VanessaJoeThreesomeMCAlone === "vanOnTop") {
        doWaitImageByTime(images.v8.V8MCJoeVanessa_38, { wait: true });
        ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaRidingMCJoeLooking, { wait: true });
        ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaCowgirl);

    } else if (Question.globalAnswers.v8VanessaJoeThreesomeMCAlone === "faceFuck") {
        ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaMCBJUpsidedownMedium, { wait: true });
        ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaMCBJUpsidedownWJoe, { wait: true });
        ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaMCBJUpsidedownFast);

    } else if (Question.globalAnswers.v8VanessaJoeThreesomeMCAlone === "doggy") {
        ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaMCDoggy);

    }

    await mc.setQuestion(new Question({ text: `I can cum or keep going...`, options: { think: true, array: "v8VanessaJoeThreesomeMCAloneArr" }, key: `v8VanessaJoeThreesomeMCAlone` })
        .option({ title: `Cowgirl`, show: empty.properties.v8ThreesomeMCAlonePosition != "vanOnTop", key: `vanOnTop` })
        .option({ title: `Missionary`, show: empty.properties.v8ThreesomeMCAlonePosition != "missionary", key: `missionary` })
        .option({ title: `Face Fuck`, show: empty.properties.v8ThreesomeMCAlonePosition != "faceFuck", key: `faceFuck` })
        .option({ title: `Doggy`, show: empty.properties.v8ThreesomeMCAlonePosition != "doggy", key: `doggy` })
        .option({ title: `Cum`, key: `cum` }));




    if (Question.globalAnswers.v8VanessaJoeThreesomeMCAlone === "cum") {
        if (empty.properties.v8ThreesomeMCAlonePosition !== "doggy") {
            mc.think(`Fuck!`);
            mc.talk(`Lean on the couch I'm about to cum!`);
            ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaMCDoggy);

        }
        vanessa.talk(`Fuck! Me!`);
        mc.talk(`Ah!!`);
        doWaitImageByTime(images.v8.V8MCJoeVanessa_48, { wait: 1 });
        doWaitImageByTime(images.v8.V8MCJoeVanessa_49);
        vanessa.talk(`I can feel it dripping...`);
        vanessa.talk(`That was great!`);
        return jump(V8VanessaJoeMCThreesome_GrabVanessa_AfterChoices, "V8VanessaJoeMCThreesome_GrabVanessa_AfterChoices");
    }

    await empty.set((properties) => {
        properties.v8ThreesomeMCAlonePosition = Question.globalAnswers.v8VanessaJoeThreesomeMCAlone;
        properties.v8ThreesomeMCAlonePositionsCounter[Question.globalAnswers.v8VanessaJoeThreesomeMCAlone] += 1;
    });

    return jump(V8VanessaJoeMCThreesome_GrabVanessa_Choices, "V8VanessaJoeMCThreesome_GrabVanessa_Choices");
};
export const V8VanessaJoeMCThreesome_GrabVanessa_AfterChoices = async (): Promise<any> => {

    doWaitImageByTime(images.v8.V8MCJoeVanessa_141);
    vanessa.talk(`Honey?`);
    joe.talk(`...`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_132);
    vanessa.talk(`Do you wanna go next?`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_132.partials.V8MCJoeVanessa_132_p);
    joe.talk(`To be honest, I think we should wrap it up here.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_134);
    vanessa.talk(`It's suppose to be a threesome!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_135);
    joe.talk(`${mc.name} already came so it's not gonna be a threesome anymore.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_136);
    vanessa.talk(`You don't have to cum at the same time!`);
    vanessa.talk(`And I'm sure I can get ${mc.name} ready to go again anyway!`);
    joe.talk(`...`);
    vanessa.talk(`Don't be a baby! Let's go!`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_137);
    joe.talk(`I'm not in the mood anymore.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_138);
    joe.talk(`I'll be in the car.`);
    vanessa.talk(`NAKED?!?`, { method: "Screaming" });
    return jump(V8VanessaJoeThreesome_Ending, "V8VanessaJoeThreesome_Ending");
};

export const V8VanessaJoeMCThreesome_DontGrabVanessa = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8MCJoeVanessa_125);
    vanessa.talk(`Are you ready for me hon?`);
    joe.talk(`More than ever!`);
    vanessa.talk(`Follow me.`);
    mc.think(`Vanessa grabbed Joey's dick and led him to the edge of the couch.`);
    doPutMultipleImages([images.v8.V8MCJoeVanessa_54, images.v8.V8MCJoeVanessa_54.partials.V8MCJoeVanessa_54_p]);
    joe.talk(`Oh yes! I missed this.`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_55);
    await joe.setQuestion(new Question({ text: `Keep going! Just like that!`, options: { think: false }, key: `v8VanessaJoeThreesomeJoeFirstJoined` })
        .option({ title: `Join them`, key: true })
        .option({ title: `Just watch`, key: false }));


    if (Question.globalAnswers.v8VanessaJoeThreesomeJoeFirstJoined) {
        return jump(V8VanessaJoeThreesome_JoinThem, "V8VanessaJoeThreesome_JoinThem");
    }



    return jump(V8VanessaJoeThreesome_JustWatch, "V8VanessaJoeThreesome_JustWatch");
};


export const V8VanessaJoeMCThreesome_JoeFirst = async (): Promise<Node<unknown>> => {
    doWaitImageByTime(images.v8.V8MCJoeVanessa_50);
    mc.talk(`I think Joey should go first...`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_50.partials.V8MCJoeVanessa_50_p);
    vanessa.talk(`Oh, really?`);
    vanessa.talk(`How novel of you!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_52);
    vanessa.talk(`Suit yourself.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_53);
    vanessa.talk(`You heard him honey, come here!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_54);
    joe.talk(`Oh fuck! I can't believe you held out on me!`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_54);
    vanessa.talk(`Mmm...`);
    let questionText = '';
    if (Question.globalAnswers.v4SexTapeAgreeToFilm) {
        mc.think(`The last time I watched them both like that was during their sex tape...`);
        if (Question.globalAnswers.v4SexTapeFuckedVanessa) {
            mc.think(`And it ended up with me fucking Vanessa.`);
            mc.think(`But this time Joey is awake...`);
            questionText = `Should I join them?`;
        } else {
            mc.think(`And I let them enjoy their time...`);
            questionText = `Should I join them this time?`;

        }

    } else {
        mc.think(`I can't believe I'm watching them doing that in front of me.`);
        questionText = `Should I join them or just let them be?`;

    }
    await mc.setQuestion(new Question({ text: questionText, options: { think: true }, key: `v8VanessaJoeThreesomeJoeFirstJoinedThem` })
        .option({ title: `Join them`, key: true })
        .option({ title: `Just watch`, key: false }));


    if (Question.globalAnswers.v8VanessaJoeThreesomeJoeFirstJoinedThem) {
        return jump(V8VanessaJoeThreesome_JoinThem, "V8VanessaJoeThreesome_JoinThem");

    }
    mc.think(`I'll just put my clothes back on and watch them.`);
    return jump(V8VanessaJoeThreesome_JustWatch, "V8VanessaJoeThreesome_JustWatch");



};

export const V8VanessaJoeThreesome_JoinThem = async (): Promise<any> => {
    mc.think(`Let's do this!`);
    mc.think(`It's suppose to be a threesome after all.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_56);
    mc.think(`She noticed...`);
    doWaitImageByTime(images.v8.Anim_V8MCJoeVanessaDoubleBJJoe.poster);
    mc.think(`That's what I'm talking about!`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaDoubleBJJoe, { wait: true });
    // doWaitImageByTime(images.v8.V8MCJoeVanessa_58);
    // mc.think(`She is switching back and forth between our dicks.`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaDoubleBTransition, { loop: 0, wait: 1.5 });
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaDoubleBJMC);
    mc.think(`Finally my turn!`);
    // doWaitImageByTime(images.v8.V8MCJoeVanessa_57);
    mc.think(`You can tell this girl is hungry...`);
    // doWaitImageByTime(images.v8.V8MCJoeVanessa_59);
    mc.think(`She feels fantastic. Seems Joey enjoys touching her as well.`); // The jump to 3rd person was jarring
    // FIXME: MC's body
    ImageClass.setImage(images.v8.V8MCJoeVanessa_60);
    vanessa.talk(`So many hands! I love this!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_61);
    vanessa.talk(`Alright boys.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_62);
    vanessa.talk(`It's time for you to sit down.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_63);
    vanessa.talk(`Good boys!`);
    vanessa.talk(`So...`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_65);
    await vanessa.setQuestion(new Question({ text: `Who wanna go first?`, options: { think: false }, key: `v8VanessaJoeThreesomeJoinedWantedToGoFirst` })
        .option({ title: `Come over here`, key: true })
        .option({ title: `Stay quiet`, key: false }));



    if (Question.globalAnswers.v8VanessaJoeThreesomeJoinedWantedToGoFirst) {
        doWaitImageByTime(images.v8.V8MCJoeVanessa_64);
        mc.talk(`Come over here!`);
        vanessa.talk(`Your wish is my command.`);
        return jump(V8VanessaJoeThreesome_JoinThem_MCFirst, "V8VanessaJoeThreesome_JoinThem_MCFirst");
    }

    vanessa.talk(`No volunteers?`);
    vanessa.talk(`No worries, I know who deserves to go first.`);
    if (mc.properties.vanessaRelationship > 10 || Question.globalAnswers.v7VanessaMarioAllowHerFuckMario || Question.globalAnswers.v8FuckedAngela) {
        return jump(V8VanessaJoeThreesome_JoinThem_MCFirst, "V8VanessaJoeThreesome_JoinThem_MCFirst");
    }

    return jump(V8VanessaJoeThreesome_JoinThem_JoeFirst, "V8VanessaJoeThreesome_JoinThem_JoeFirst");
};
export const V8VanessaJoeThreesome_JoinThem_MCFirst = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8MCJoeVanessa_67);
    await mc.set((properties) => {
        properties.v8ThreesomeWentFirst = true;
    });
    await empty.set((properties) => {
        properties.v8ThreesomeState = "standing";
    });
    if (!Question.globalAnswers.v8VanessaJoeThreesomeJoinedWantedToGoFirst) {
        mc.think(`Oh shit! She picked me over her own boyfriend.`);
    }
    vanessa.talk(`Let me feel this cock!`);
    if (Question.globalAnswers.v4SexTapeFuckedVanessa || Question.globalAnswers.v6HadSexVanessaLivingRoom) {
        mc.think(`Like she hasn't felt it before... But she's gotta keep up the act.`);

    }
    doWaitImageByTime(images.v8.Anim_V8MCJoeVanessaRidingMCNearJoe.poster);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaRidingMCNearJoe);
    vanessa.talk(`Fuck! It feels bigger than it looks!`);

    doWaitImageByTime(images.v8.V8MCJoeVanessa_78);
    joe.talk(`Don't forget about me!`);
    vanessa.talk(`What are you waiting for?`);
    doImageShake(images.v8.V8MCJoeVanessa_79);
    vanessa.talk(`YES!!!`);
    mc.think(`That scream... Did he just stick it inside her ass?`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_80);
    mc.think(`He must have.`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_79);
    vanessa.talk(`Yes big boys! Fuck me!`);
    mc.think(`She is definitely excited.`);
    joe.talk(`Yo ${mc.name}, let's stand.`);


    return jump(V8VanessaJoeThreesome_JoinThem_StandingUpJoeAnal, "V8VanessaJoeThreesome_JoinThem_StandingUpJoeAnal");
};
export const V8VanessaJoeThreesome_JoinThem_JoeFirst = async (): Promise<any> => {
    doWaitImageByTime(images.v8.Anim_V8MCJoeVanessaRidingJoe.poster);
    await mc.set((properties) => {
        properties.v8ThreesomeWentFirst = false;
    });

    await empty.set((properties) => {
        properties.v8IsMCAnal = true;
        properties.v8ThreesomeState = "sitting";
    });

    mc.think(`She picked Joey.`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaRidingJoe);
    vanessa.talk(`Don't worry. You'll get your turn.`);
    mc.think(`My turn?`);
    mc.think(`Why do I have to wait... She has more than one hole...`);
    doWaitImageByTime(v8.V8MCJoeVanessa_70);
    vanessa.talk(`You have no patience...`);
    doImageShake(v8.V8MCJoeVanessa_71);
    vanessa.talk(`FUCK! YES!`);
    mc.think(`I knew she wanted it.`);
    doWaitImageByTime(images.v8.Anim_V8MCJoeVanessaDPMCAnal.poster);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaDPMCAnal);
    mc.think(`Her ass is so tight and yet my cock slid right in!`);



    return jump(V8VanessaJoeThreesome_JoinThem_Choices, "V8VanessaJoeThreesome_JoinThem_Choices");
};

export const V8VanessaJoeThreesome_JoinThem_StandingUpJoeAnal = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8MCJoeVanessa_84);
    mc.think(`We both stood up, keeping both our cocks in her.`);
    vanessa.talk(`Yes! I fucking love this!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_85);
    mc.think(`We both started to bounce her up and down on our cocks, treating her like our own sex toy.`);
    vanessa.talk(`Ah...`);

    return jump(V8VanessaJoeThreesome_JoinThem_Choices, "V8VanessaJoeThreesome_JoinThem_Choices");
};


export const V8VanessaJoeThreesome_JoinThem_Choices = async (): Promise<any> => {
    if (Question.globalAnswers.v8VanessaJoeThreesomeBothChoices === "standUp") {
        // V8VanessaJoeThreesome_JoinThem_Choices_Standing();
        await empty.set((properties) => {
            properties.v8ThreesomeState = "standing";
        });
        V8VanessaJoeThreesome_JoinThem_Choices_Switching();
    } else
        if (Question.globalAnswers.v8VanessaJoeThreesomeBothChoices === "blowjob") {
            V8VanessaJoeThreesome_JoinThem_Choices_Blowjob();
            await empty.set((properties) => {
                properties.v8ThreesomeState = "blowjob";
            });
        } else if (Question.globalAnswers.v8VanessaJoeThreesomeBothChoices === "sitBackDown") {
            // if (empty.properties.v8IsMCAnal) {
            //     doWaitImageByTime(images.v8.V8MCJoeVanessa_71);
            // } else {
            //     doWaitImageByTime(images.v8.V8MCJoeVanessa_79);
            // }
            await empty.set((properties) => {
                properties.v8ThreesomeState = "sitting";
            });
            V8VanessaJoeThreesome_JoinThem_Choices_Switching();
        } else if (Question.globalAnswers.v8VanessaJoeThreesomeBothChoices === "switchWithJoe") {
            await empty.set((properties) => {
                properties.v8IsMCAnal = !properties.v8IsMCAnal;
            });
            V8VanessaJoeThreesome_JoinThem_Choices_Switching();

        }

    // TODO: check the key sitBackDown for keep fucking
    await mc.setQuestion(new Question({ text: ``, options: { think: true, array: 'v8VanessaJoeThreesomeBothChoicesArr' }, key: `v8VanessaJoeThreesomeBothChoices` })
        .option({ title: `Blowjob`, show: empty.properties.v8ThreesomeState === "sitting" && empty.properties.v8IsMCAnal, key: `blowjob` }) // can only happen if sitting down
        .option({ title: `Keep fucking`, show: empty.properties.v8ThreesomeState === "blowjob", key: `sitBackDown` }) // can only happen if getting blowjob
        .option({ title: `Switch With Joey`, show: empty.properties.v8ThreesomeState !== "blowjob", key: `switchWithJoe` }) // can happen if not "Finish"
        .option({ title: `Sit back down`, show: empty.properties.v8ThreesomeState === "standing", key: `sitBackDown` }) // can only happen if standing
        .option({ title: `Stand up`, show: empty.properties.v8ThreesomeState === "sitting", key: `standUp` }) // can only happen if sitting
        .option({ title: `Finish`, key: `finish` })); // can always happen 

    await empty.set((properties) => {
        properties.v8ThreesomeStateCounter[Question.globalAnswers.v8VanessaJoeThreesomeBothChoices] += 1;
    });

    if (Question.globalAnswers.v8VanessaJoeThreesomeBothChoices === "finish") {
        return jump(V8VanessaJoeThreesome_JoinThem_Choices_Finish, "V8VanessaJoeThreesome_JoinThem_Choices_Finish");
    }


    return jump(V8VanessaJoeThreesome_JoinThem_Choices, "V8VanessaJoeThreesome_JoinThem_Choices");
};
export const V8VanessaJoeThreesome_JoinThem_Choices_Blowjob = async (): Promise<any> => {
    // never jump to this scene, only call it. it has no return value;
    if (empty.properties.v8ThreesomeStateCounter.blowjob === 1) {
        mc.think(`Even though it's in her ass I'm dying to get my dick sucked!`);
        doWaitImageByTime(v8.V8MCJoeVanessa_73);
        mc.think(`She looks surprised.`);
        doWaitImageByTime(v8.V8MCJoeVanessa_74);
        mc.think(`Fuck yes!`);
        doWaitImageByTime(v8.V8MCJoeVanessa_76);
        vanessa.talk(`Slurp`);
        doWaitImageByTime(v8.V8MCJoeVanessa_77);
        vanessa.talk(`Did you think I care?`);
        mc.talk(`Not really.`);
        // TODO: fix this animation
        // doWaitImageByTime(images.v8.Anim_V8MCJoeVanessaRidingJoeBJMC.poster);
        // ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaRidingJoeBJMC);

    } else {
        doWaitImageByTime(images.v8.V8MCJoeVanessa_77, { wait: true });
        doWaitImageByTime(images.v8.V8MCJoeVanessa_76, { wait: true });
        doWaitImageByTime(images.v8.Anim_V8MCJoeVanessaRidingJoeBJMC.poster);
        ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaRidingJoeBJMC);

    }
};
export const V8VanessaJoeThreesome_JoinThem_Choices_Standing = async (): Promise<any> => {
    // never jump to this scene, only call it. it has no return value;
    if (empty.properties.v8IsMCAnal) {
        doWaitImageByTime(images.v8.V8MCJoeVanessa_82);
    } else {
        doWaitImageByTime(images.v8.V8MCJoeVanessa_84);
    }
};
export const V8VanessaJoeThreesome_JoinThem_Choices_Switching = async (): Promise<any> => {
    // never jump to this scene, only call it. it has no return value;

    if (empty.properties.v8ThreesomeState === "standing") {
        if (!empty.properties.v8IsMCAnal) {
            doWaitImageByTime(images.v8.V8MCJoeVanessa_84, { wait: true });
            doWaitImageByTime(images.v8.V8MCJoeVanessa_85);
        } else {
            doWaitImageByTime(images.v8.V8MCJoeVanessa_82, { wait: true });
            doWaitImageByTime(images.v8.V8MCJoeVanessa_81, { wait: true });
            doWaitImageByTime(images.v8.Anim_V8VanessaMCJoeThreesomeDP.poster);
            ImageClass.setAnimation(images.v8.Anim_V8VanessaMCJoeThreesomeDP);
        }
    } else { //sitting down
        if (!empty.properties.v8IsMCAnal) {
            doWaitImageByTime(images.v8.V8MCJoeVanessa_78, { wait: true });
            doWaitImageByTime(images.v8.V8MCJoeVanessa_80, { wait: true });
            doWaitImageByTime(images.v8.V8MCJoeVanessa_79);
        } else {
            doWaitImageByTime(images.v8.V8MCJoeVanessa_70, { wait: true });
            doWaitImageByTime(images.v8.V8MCJoeVanessa_71, { wait: true });
            doWaitImageByTime(images.v8.Anim_V8MCJoeVanessaDPMCAnal.poster);
            ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaDPMCAnal);
            // doWaitImageByTime(images.v8.V8MCJoeVanessa_80, { wait: true });
        }
    }

};

export const V8VanessaJoeThreesome_JoinThem_Choices_Finish = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8MCJoeVanessa_86);
    vanessa.talk(`Does that feel good?`);
    doWaitImageByTime(images.v8.Anim_V8MCJoeVanessaDoubleHJ.poster);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaDoubleHJ);
    mc.talk(`Fuck! Yes! I'm cumming!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_88);
    vanessa.talk(`Slurp!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_89);
    vanessa.talk(`Ahh...`);
    joe.talk(`Babe, I'm cumming!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_90);
    vanessa.talk(`Slurp!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_91);
    vanessa.talk(`Ahhh...`);
    joe.talk(`Damn, that's hot.`);

    return jump(V8VanessaJoeThreesome_Ending, "V8VanessaJoeThreesome_Ending");
};


export const V8VanessaJoeThreesome_JustWatch = async (): Promise<any> => {
    if (Question.globalAnswers.v7JoeGymToldBreakupVanessa) {
        mc.think(`It's their break-up sex after all...`);

    } else {
        mc.think(`They are trying to fix their relationship... I'll just watch.`);

    }
    if (isMcLikesNTR()) {
        mc.think(`Besides... Watching them hit it off is so hot!`);
        mc.think(`The last time I saw them in my living room I had to hide. Now I got a front row seat.`);
    }
    doWaitImageByTime(images.v8.V8MCJoeVanessa_93);
    mc.think(`Why is she giving me this nasty look...`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_94);
    vanessa.talk(`Slurp!`);
    mc.think(`Is she trying to tease me?`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_95);
    mc.think(`She's coming over... What is she going to do?`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_96);
    if (Question.globalAnswers.v8VanessaJoeThreesomeGrabbedVanessaLetJoeyJoin) {
        vanessa.talk(`Since you put your clothes back on...`);
    } else {
        vanessa.talk(`Since you're just watching...`);

    }
    doWaitImageByTime(images.v8.V8MCJoeVanessa_97);

    if (Question.globalAnswers.v8VanessaJoeThreesomeGrabbedVanessaLetJoeyJoin) {
        vanessa.talk(`I guess you aren't going to participate longer.\nSo here, hold those for me.`);
    } else {
        vanessa.talk(`Hold those for me.`);
    }

    doWaitImageByTime(images.v8.V8MCJoeVanessa_98.partials.V8MCJoeVanessa_98_p, { putParent: true });
    vanessa.talk(`Honey! I'm ready for you!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_98);
    vanessa.talk(`I hope you are enjoying the show so far.`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_99);
    mc.talk(`I am.`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_101);
    vanessa.talk(`Do you have a good angle? I want you to see everything!`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_102, { shake: true, duration: 0 });
    vanessa.talk(`Fuck!`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_103);
    vanessa.talk(`Yes!!!`);
    ImageClass.setImage(images.v8.Anim_V8MCJoeVanessaJoeDoggy.poster);
    vanessa.talk(`Fuck me!`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaJoeDoggy, { wait: true });
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaJoeDoggy, { speed: 1.4 });
    vanessa.talk(`Faster!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_104);
    vanessa.talk(`I can't believe you came here just to watch us both.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_105);
    joe.talk(`Come here!`);
    vanessa.talk(`I'm all yours babe.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_106);
    vanessa.talk(`Fuck.`);
    ImageClass.setImage(images.v8.Anim_V8MCJoeVanessaJoeFucking.poster);
    vanessa.talk(`This could've been you.`);
    vanessa.talk(`But...`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaJoeFucking);
    vanessa.talk(`Fuck!`);
    vanessa.talk(`It's...`);
    vanessa.talk(`not!`);
    vanessa.talk(`Fuck!`);
    joe.talk(`I'm close!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_111, null, 1);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_112);
    joe.talk(`Ahhhh!!!`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_113);
    vanessa.talk(`Slurp!`);
    vanessa.talk(`Oh my! That's a lot.`);
    vanessa.talk(`It's like someone was holding you back...`);
    joe.talk(`...`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_114);
    await vanessa.setQuestion(new Question({ text: `What do you say? Do I look beautiful?`, options: { think: false }, key: `v8VanessaJoeThreesomeSaidVanessaLookBeautiful` })
        .option({ title: `Yes`, key: true })
        .option({ title: `No`, key: false }));

    if (Question.globalAnswers.v8VanessaJoeThreesomeSaidVanessaLookBeautiful) {
        mc.talk(`You do.`);
        await mc.set((properties) => {
            properties.vanessaRelationship++;
        });
    } else {
        mc.talk(`You don't.`);
        vanessa.talk(`You know nothing ${mc.name}!`);
    }

    doWaitImageByTime(images.v8.V8MCJoeVanessa_115);
    vanessa.talk(`Oh! What's that? I see you enjoyed our little show.`);
    vanessa.talk(`I can't leave you like this, how about some relief?`);
    await vanessa.setQuestion(new Question({ text: `I can't leave you like this, how about some relief?`, options: { think: false }, key: `v8VanessaJoeThreesomeOnlyJoeAcceptedHandjob` })
        .option({ title: `Accept handjob`, key: true })
        .option({ title: `Refuse`, key: false }));

    if (Question.globalAnswers.v8VanessaJoeThreesomeOnlyJoeAcceptedHandjob) {
        return jump(V8VanessaJoeThreesome_JustWatch_AcceptHandjob, "V8VanessaJoeThreesome_JustWatch_AcceptHandjob");
    }

    return jump(V8VanessaJoeThreesome_JustWatch_RefuseHandjob, "V8VanessaJoeThreesome_JustWatch_RefuseHandjob");

};
export const V8VanessaJoeThreesome_JustWatch_AcceptHandjob = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8MCJoeVanessa_117);
    vanessa.talk(`Oh there it is!`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_118);
    mc.think(`Damn... She is such a slut!`);
    ImageClass.setImage(images.v8.Anim_V8MCJoeVanessaHJ.poster);
    mc.think(`Damn it feels so good.`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaHJ);
    mc.think(`The way she is stroking my cock while her face is covered with cum.`);
    ImageClass.setAnimation(images.v8.Anim_V8MCJoeVanessaHJ, { speed: 1.4 });
    mc.talk(`Ah...`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_122);
    vanessa.talk(`There we go.`);
    ImageClass.setImage(images.v8.V8MCJoeVanessa_123);
    vanessa.talk(`Too bad... That could've been inside of me...`);
    vanessa.talk(`There is only one way of getting it in now...`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_124);
    vanessa.talk(`*Lick...*`);
    // V8MCJoeVanessa_124_2 talking
    vanessa.talk(`It wasn't as I imagined it, but this will do.`);
    vanessa.talk(`For now.`);

    joe.talk(`Are we ready to go?`);
    vanessa.talk(`Yes. Nothing else to do here.`);

    return jump(V8VanessaJoeThreesome_Ending, "V8VanessaJoeThreesome_Ending");
};
export const V8VanessaJoeThreesome_JustWatch_RefuseHandjob = async (): Promise<any> => {
    mc.talk(`I'm good.`);
    doWaitImageByTime(images.v8.V8MCJoeVanessa_116);
    if (Question.globalAnswers.v3VanessaCoffeeLikedWatchingVanessaJoeFuck) {
        vanessa.talk(`Figured as much.`);
        vanessa.talk(`I'm gonna have to start charging you at some point.`);
    } else {
        vanessa.talk(`Suit yourself.`);
    }


    return jump(V8VanessaJoeThreesome_Ending, "V8VanessaJoeThreesome_Ending");
};

export const V8VanessaJoeThreesome_Ending = async (): Promise<any> => {
    await endReplay(replayScenesList.v8McVanessaJoeThreesome);
    if (Question.globalAnswers.v8VanessaJoeThreesomeGrabbedVanessaLetJoeyJoin === false) {
        // Only MC
        doWaitImageByTime(images.v8.V8MCJoeVanessa_140);
        vanessa.talk(`Wow, you really fucked that up.`);
        ImageClass.setImage(images.v8.V8MCJoeVanessa_139);
        mc.talk(`You both agreed I can do whatever I wanted to feel comfortable.`);
        ImageClass.setImage(images.v8.V8MCJoeVanessa_140);
        vanessa.talk(`That's true, but you know...`);
        ImageClass.setImage(images.v8.V8MCJoeVanessa_139);
        mc.talk(`I guess I just got carried away...\nLet's get to the car before it's going to get even more awkward.`);
        ImageClass.setImage(images.v8.V8MCJoeVanessa_140);
        vanessa.talk(`I agree.`);


        doTransition(v8.V8BeforeUnderpass_12);
        mc.talk(`Hey man... Thanks for the...`);
        ImageClass.setImage(images.v8.V8BeforeUnderpass_13);
        mc.talk(`Ride...`);
        // drives off
        doWaitImageByTime(v8.V8BeforeUnderpass_14);
        mc.think(`Well... Guess that was to be expected...`);


    } else if (Question.globalAnswers.v8VanessaJoeThreesomeJoeFirstJoinedThem === false) {
        // Only Joey
        doTransition(v8.V8BeforeUnderpass_9);
        joe.talk(`There we are...`);
        ImageClass.setImage(images.v8.V8BeforeUnderpass_8);
        mc.talk(`Thanks man.`);

        ImageClass.setImage(images.v8.V8BeforeUnderpass_10);
        joe.talk(`Too bad you didn't join us.`);
        ImageClass.setImage(images.v8.V8BeforeUnderpass_11);
        mc.talk(`It's fine, it was my decision.`);
        ImageClass.setImage(v8.V8BeforeUnderpass_9);
        joe.talk(`Yeah...\nWell, good night bro.`);
        doWaitImageByTime(v8.V8BeforeUnderpass_14, { wait: true });

    } else {
        // Both
        doWaitImageByTime(v8.V8MCJoeVanessa_92);
        vanessa.talk(`Wasn't it worth your while coming?`);
        vanessa.talk(`And cumming...`);
        mc.talk(`It really was!`);
        // outside house
        doTransition(v8.V8BeforeUnderpass_9);
        joe.talk(`Thanks for coming bro! I'll talk to you tomorrow!`);
        ImageClass.setImage(images.v8.V8BeforeUnderpass_8);
        mc.talk(`Sure thing, good night!`);
        doWaitImageByTime(v8.V8BeforeUnderpass_14, { wait: true });
    }

    return jump(V8VanessaJoeMCThreesomeAfter, "V8VanessaJoeMCThreesomeAfter");
};
